import React, { Component } from 'react';
import './Ribbon.css';

export class Ribbon extends Component {
    static displayName = Ribbon.name;

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div className="corner-ribbon top-left sticky red shadow">{process.env.REACT_APP_ENV}</div>
        );
    }
}